import React, { FC } from "react";
import {
  ArrayField,
  Datagrid,
  DateField,
  ImageField,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from "react-admin";

export const ShowComponent: FC = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="Id" source="id" />
      <TextField label="First name" source="first_name" />
      <TextField label="Last name" source="last_name" />
      <TextField label="Email" source="email" />
      <DateField label="Created at" source="created_at" />
      <DateField label="Updated at" source="updated_at" />
      <ImageField label="Avatar" source="avatar" />
      <ArrayField source="members">
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="organization.name" />
          <TextField source="role" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
